import type { ReactNode } from 'react';

/**
 * A list screen's heading: the title, the line under it, and the screen's own controls
 * on the far side — the period picker and the export on reports, say. Written once so
 * every screen's heading sits at the same size and spacing; `children` holds anything
 * that belongs under the line, like the talents screen's note on badges.
 */
export function PageHeader({
  title,
  sub,
  actions,
  children,
}: {
  title: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <header className="flex flex-wrap items-center justify-between gap-4">
      <div>
        <h2 className="text-lg font-bold text-navy">{title}</h2>
        {sub !== undefined && <p className="text-[12.5px] text-conc-500">{sub}</p>}
        {children}
      </div>
      {actions !== undefined && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
    </header>
  );
}
